module.exports = __webpack_public_path__ + "img/ag.svg";